<template>
  <div class="d-flex align-center justify-center fill-height">
    <div class="d-flex" xs12 sm8 md4>
      <v-card class="elevation-12">
        <v-card-title>
          <h5 class="text-h5 text-center text-error">
            Not found
          </h5>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn class="bg-primary" to="/">
            Home
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
